// Author YuJiaBei
// Date 2020-08-07 15:55:23

class EmLcScrRecordSre {
constructor({
        id = null,
        sreCodeBda = '',
        sreCodeLoc = '',
        sreIdOriginator = '',
        sreIdOriginatorLoginName = '',
        sreIdSrea = '',
        sreDate = '',
        sreAttachment = '',
        sreReasonDescription = '',
        sreAttachmentList = ''}
= {}) {
    this.id = id;
    this.sreCodeBda = sreCodeBda;
    this.sreCodeLoc = sreCodeLoc;
    this.sreIdOriginator = sreIdOriginator;
    this.sreIdOriginatorLoginName = sreIdOriginatorLoginName;
    this.sreIdSrea = sreIdSrea;
    this.sreDate = sreDate;
    this.sreAttachment = sreAttachment;
    this.sreReasonDescription = sreReasonDescription;
    this.sreAttachmentList = sreAttachmentList;
}
}

function newEntity() {
return new EmLcScrRecordSre();
}

function gridFields() {
return Object.freeze([
        {
        key: 'status',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.status',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sreCodeBda',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.sreCodeBda',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBdaName',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.emArchBdaName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sreCodeLoc',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.sreCodeLoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchLocName',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.emArchLocName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sreIdOriginatorLoginName',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.sreIdOriginatorLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sreIdSrea',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.sreIdSrea',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sreDate',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.sreDate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sreAttachmentList',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.sreAttachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'sreReasonDescription',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.sreReasonDescription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.lifecycle.emLcScrRecordSre.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    statusFilter : "",
    workOrderCodeFilter : "",
    sreCodeBdaFilter : "",
    sreCodeLocFilter : "",
    sreIdOriginatorFilter : "",
    sreIdOriginatorLoginNameFilter : "",
    sreIdSreaFilter : "",
    sreDateRteFilter : "",
    sreDateLteFilter : "",
    workflowQueryTypeFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : "",
    emArchLocCodeFilter : "",
    emArchLocNodeCodeFilter : "",
    emArchLocNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'statusFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'EmLcScrRecordSre',statusFilter:1}
        }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sreCodeBdaFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.sreCodeBda',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sreIdOriginatorLoginNameFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.sreIdOriginatorLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"sreIdOriginator":"id"}'
                }
        },
        {
        key: 'sreIdSreaFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.sreIdSrea',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'sreDateRteFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.sreDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'sreDateLteFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.sreDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        },
        {
        key: 'emArchLocCodeFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.emArchLocCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emArchLocNodeCodeNameFilter',
        label: 'label.em.lifecycle.emLcScrRecordSre.filter.emArchLocNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emArchLocNodeCode":"nodeCode"}'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'sreCodeBda',
        label: 'label.em.lifecycle.emLcScrRecordSre.entity.sreCodeBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sreCodeLoc',
        label: 'label.em.lifecycle.emLcScrRecordSre.entity.sreCodeLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'sreIdOriginatorLoginName',
        label: 'label.em.lifecycle.emLcScrRecordSre.entity.sreIdOriginatorLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"sreIdOriginator":"id"}'
                }
        },
        {
        key: 'sreIdSrea',
        label: 'label.em.lifecycle.emLcScrRecordSre.entity.sreIdSrea',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'sreDate',
        label: 'label.em.lifecycle.emLcScrRecordSre.entity.sreDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
            ,required: true
                }
        },
        {
        key: 'sreReasonDescription',
        label: 'label.em.lifecycle.emLcScrRecordSre.entity.sreReasonDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'sreAttachmentList',
        label: 'label.em.lifecycle.emLcScrRecordSre.entity.sreAttachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'sreAttachment'
                }
        }
]

export {EmLcScrRecordSre, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
